import React, { useState, useEffect, useCallback } from "react";
import { Button, Modal, Input, Checkbox } from "antd";
import "../../assets/css/otpModal.css";
import useHttp from "./../../hooks/useHttp";
import { APP_URL, urlParams } from "./../../constants/AppConstants";
import mailPng from "./../../assets/icons/Mail.png";
import { getController } from "./../../context/AppContext";
import { successNotification } from "../../pages/utils/CommonNotifications";
import useUsers from "../../hooks/useUsers";
import OtpInput from "../../pages/Login/OtpInput";
import { OTP_MODAL_EXCLUDE_PATHS } from "../../pages/utils/commonUtils";
import { AwsWafCaptcha } from "./CaptchaWidget";

const { Search } = Input;

export default function OTPModal(props) {
  const { open, setLoading, appPropsObject, showCaptchaWidget, setShowCaptchaWidget } = props;
  const [isModalOpen, setIsModalOpen] = useState(open);
  const [currentStep, setCurrentStep] = useState("1");
  const leftServiceId = urlParams.get("leftServiceId");
  const rightServiceId = urlParams.get("rightServiceId");
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [otpBtnLoading, setOtpBtnLoading] = useState(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState(true);
  const [emailMessageContent, setEmailMessageContent] = useState(true);
  const [controller] = useState(getController(window.location.path === "/zoho-crm/webhook" ? "zohocrm" : urlParams.get("service") ?? "default"));
  const [emailLoading, setEmailLoading] = useState(true);
  const [emailDisable, setEmailDisable] = useState(false);
  const [email, setEmail] = useState(urlParams.get("email"));
  const [cookiesBlocked, setCookiesBlocked] = useState(false);
  const [otpGlobal, setOtpGlobal] = useState(null);
  const isInIframe = window.self !== window.top;

  const onChange = (e) => {
    setChecked(e.target.checked);
  };

  const { fetchData } = useHttp();

  useEffect(() => {
    if (!isInIframe) return;
    const handleMessage = (event) => {
      if (
        typeof event.data === "object" &&
        event.data?.eventType === "third-party-cookie-check" &&
        event.data?.thirdPartyCookiesEnabled === false
      ) {
        setCookiesBlocked(true);
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [isInIframe]);

  const login = () => {
    let companyId = appPropsObject?.companyId;
    let userId = appPropsObject?.userId;
    let appPropObj = { companyId, userId };
    setOtpBtnLoading(true);
    fetchData(
      `login?email=${encodeURIComponent(
        email
      )}&companyId=${companyId}&leftServiceId=${leftServiceId}&rightServiceId=${rightServiceId}&userDetail=${userId}&rememberMe=${checked}`,
      "POST",
      null,
      appPropObj
    ).then(function (response) {
      if (response) {
        const responseData = JSON.parse(response);
        if (responseData?.data?.emailResponse?.isValid) {
          successNotification("OTP Sent");
          setOtpBtnLoading(false);
          setCurrentStep("2");
        } else {
          setEmailMessageContent(responseData?.data?.emailResponse?.message);
          setDisabled(false);
          setOtpBtnLoading(false);
        }
      }
    });
  };

  const { getUserAccountDetails } = useUsers();
  useEffect(() => {
    if (!controller) return;

    let accountAvailable = false;

    if (!email || email === "null" || email === "undefined") {
      let companyId = appPropsObject?.companyId;
      let userId = appPropsObject?.userId;
      getUserAccountDetails(companyId, userId, leftServiceId, controller, appPropsObject)
        .then((response) => {
          if (response) {
            const responseData = response?.data?.data;
            if (responseData) {
              let dataObj = JSON.parse(responseData);
              if (dataObj) {
                const email = dataObj?.email;
                if (email) {
                  setEmail(email);
                  setEmailDisable(true);
                  setEmailLoading(false);
                }
              }
            }
            accountAvailable = response?.data?.accountAvailable;
            if (OTP_MODAL_EXCLUDE_PATHS.includes(window.location.pathname)) {
              if (!accountAvailable) {
                setIsModalOpen(false);
              }
            }
          }
        })
        .finally(() => {
          setEmailLoading(false);
          setLoading(false);
        });
    } else {
      setEmailLoading(false);
    }
  }, [controller]);

  return (
    <>
      <Modal
        id="otp"
        className="otpModal"
        maskClosable={false}
        open={isModalOpen && !emailLoading}
        footer={null}
        centered={true}
        closeIcon={false}
      >
        <div id="modalContainer" style={{ marginTop: "2px", marginBottom: ".5rem" }}>
          <div id="otpModalIconDiv">
            <img src={mailPng} draggable="false" alt="mail.png" />
          </div>

          {currentStep === "1" && (
            <GetEmail
              otpBtnLoading={otpBtnLoading}
              login={login}
              setDisabled={setDisabled}
              disabled={disabled}
              emailMessageContent={emailMessageContent}
              onChange={onChange}
              controller={controller}
              emailLoading={emailLoading}
              setEmailLoading={setEmailLoading}
              emailDisable={emailDisable}
              email={email}
              setEmail={setEmail}
              appPropsObject={appPropsObject}
            />
          )}
          {currentStep === "2" && (
            <GetOTP
              email={email}
              checked={checked}
              setOtpErrorMessage={setOtpErrorMessage}
              otpErrorMessage={otpErrorMessage}
              login={login}
              setOtpModalState={props.setOtpModalState}
              controller={controller}
              leftServiceId={leftServiceId}
              rightServiceId={rightServiceId}
              appPropsObject={appPropsObject}
              showCaptchaWidget={showCaptchaWidget}
              setShowCaptchaWidget={setShowCaptchaWidget}
              setOtpGlobal={setOtpGlobal}
              otpGlobal={otpGlobal}
            />
          )}
          {isInIframe && (
            <iframe src={`${APP_URL}/api/v2/third-party-cookie-check`} style={{ display: "none" }} title="third-party-cookie-check" />
          )}
          {cookiesBlocked && (
            <div className="rounded-3 hs-border-light-red hs-bg-light-red p-2">
              <div className="d-flex align-items-center">
                <div className="actionIconsSprite cookie-blocked me-1" />
                <strong className="hs-color-maroon">Cookies are blocked</strong>
              </div>
              <div className="ps-4 ms-1 hs-color-light-maroon">Please enable third-party cookies in your browser.</div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}

const GetEmail = (props) => {
  const { login, setDisabled, disabled, emailMessageContent, onChange, otpBtnLoading, emailLoading, emailDisable, email, setEmail } = props;

  return (
    <div id="otpModal" data-cy="otp-modal">
      <p className="commonStyleHeading"> Email Verification </p>
      <p className="commonStyleMessage" style={{ marginBottom: "2rem" }}>
        {" "}
        Please enter your registered email address. An OTP will be sent to verify your account.{" "}
      </p>
      <div id="otpEmailInput" className="shadow-sm">
        <Search
          loading={otpBtnLoading}
          prefix={emailLoading ? <div className="actionIconsSprite search-loading"></div> : <></>}
          allowClear={false}
          enterButton={
            <Button type="primary" size="large" disabled={otpBtnLoading} data-cy="get-otp">
              Get OTP
            </Button>
          }
          size="large"
          onSearch={login}
          disabled={emailDisable}
          onChange={(e) => {
            setEmail(e.target.value);
            setDisabled(true);
          }}
          variant="borderless"
          autosize={true}
          value={email}
        />
        <div className="d-flex" style={{ paddingLeft: "12px", paddingTop: "6px" }}>
          <p style={{ color: "red" }} hidden={disabled}>
            {emailMessageContent}
          </p>
        </div>
      </div>
      <div className="d-flex align-items-end flex-column bd-highlight mb-3" style={{ paddingRight: "10px", fontSize: "large" }}>
        <p
          style={{
            marginBottom: "20px",
          }}
        >
          <Checkbox onChange={onChange} className="d-none">
            Remember Me
          </Checkbox>
        </p>
      </div>
    </div>
  );
};

const GetOTP = (props) => {
  let controller = props.controller;

  const {
    email,
    setOtpErrorMessage,
    otpErrorMessage,
    checked,
    login,
    setOtpModalState,
    leftServiceId,
    rightServiceId,
    appPropsObject,
    showCaptchaWidget,
    setShowCaptchaWidget,
    setOtpGlobal,
    otpGlobal,
  } = props;

  const [hashToken, setHashToken] = useState();
  const [isRequestSentForValidation, setIsRequestSentForValidation] = useState(false);
  const [otpResponseData, setOtpResponseData] = useState();
  const companyId = urlParams.get("companyId");
  const userId = urlParams.get("userId");
  const [otpMessageContent, setOtpMessageContent] = useState(true);
  const { fetchData } = useHttp();
  const [otp, setOtp] = useState(Array(4).fill(""));
  useEffect(() => {
    if (hashToken) {
      controller
        ?.saveApplicationToken(hashToken)
        .then(function () {
        if (otpResponseData?.data?.otpResponse?.isValid) {
          setOtpModalState(false);
          window.location.reload();
        } else {
          setIsRequestSentForValidation(false);
          setOtpMessageContent(otpResponseData?.data?.otpResponse?.message);
          setOtpErrorMessage(false);
        }
      })
        .catch(() => {
          window.location.reload();
        });
    }
  }, [hashToken, controller]);
  const handleOtpChange = () => {
    setIsRequestSentForValidation(false);
  };

  const setTokenAsCookie = (token, days = 1) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `aws-waf-token=${token}; expires=${expires.toUTCString()}; path=/; SameSite=Strict; Secure; domain=.rekzyl.com`;
  };

  const handleCaptchaSuccess = (token) => {
    setTokenAsCookie(token);
    const otpString = Array.isArray(otp) ? otp.join("") : otp;
    validateOtp(otpGlobal || otpString, token);
    // setOtpModalState(false);
    setShowCaptchaWidget(false);
  };

  const handleCaptchaError = (error) => {
    console.error("CAPTCHA failed:", error);
  };

  const validateOtp = useCallback(
    (otpValues, wafToken) => {
      if (!isRequestSentForValidation) {
        setIsRequestSentForValidation(true);
        let companyId = appPropsObject?.companyId;
        let userId = appPropsObject?.userId;
        let captchaToken = wafToken ? wafToken : null;

        fetchData(
          `validate?otp=${otpValues}&companyId=${companyId}&leftServiceId=${leftServiceId}&rightServiceId=${rightServiceId}&userDetail=${userId}&rememberMe=${checked}&email=${email}`,
          "POST",
          null,
          appPropsObject,
          captchaToken && { "x-aws-waf-token": captchaToken }
        )
          .then(function (response) {
            if (response) {
              const responseData = JSON.parse(response);

              let hashTokenFromServer = responseData?.data?.token;
              if (hashTokenFromServer) {
                setOtpResponseData(responseData);
                setHashToken(hashTokenFromServer);
                setShowCaptchaWidget(false);
              } else {
                if (responseData?.data?.otpResponse?.isValid) {
                  setOtpModalState(false);
                  setShowCaptchaWidget(false);
                  window.location.reload();
                } else {
                  setOtpMessageContent(responseData?.data?.otpResponse?.message);
                  setOtpErrorMessage(false);
                  setShowCaptchaWidget(false);
                }
              }
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    [fetchData, checked, companyId, leftServiceId, rightServiceId, setOtpErrorMessage, setOtpModalState, email, userId, hashToken]
  );

  return (
    <>
      {showCaptchaWidget ? (
        <div id="otpModal">
          <AwsWafCaptcha
            apiKey={process.env.REACT_APP_AWS_WAP_CAPTCHA_KEY}
            integrationUrl={process.env.REACT_APP_AWS_WAF_INTEGRATION_URL}
            onSuccess={handleCaptchaSuccess}
            onError={handleCaptchaError}
            className="mb-4"
            theme="dark"
            size="normal"
          />
        </div>
      ) : (
        <div id="otpModal">
          <p className="commonStyleHeading"> Email Verification </p>
          <p>
            {" "}
            <span className="commonStyleMessage">Enter the OTP sent to</span> <br />{" "}
            <span style={{ fontSize: "small", fontWeight: "bolder", opacity: "revert" }}>{email}</span>{" "}
          </p>
          <OtpInput
            otp={otp}
            setOtp={setOtp}
            validateOtp={validateOtp}
            otpMessageContent={otpMessageContent}
            email={email}
            otpErrorMessage={otpErrorMessage}
            setOtpErrorMessage={setOtpErrorMessage}
            setIsRequestSentForValidation={setIsRequestSentForValidation}
            login={login}
            onChange={handleOtpChange}
            setOtpGlobal={setOtpGlobal}
          />
        </div>
      )}
    </>
  );
};
